import { render, staticRenderFns } from "./CalendarComp.vue?vue&type=template&id=167109f8&scoped=true&"
import script from "./CalendarComp.vue?vue&type=script&lang=js&"
export * from "./CalendarComp.vue?vue&type=script&lang=js&"
import style0 from "./CalendarComp.vue?vue&type=style&index=0&id=167109f8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "167109f8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCalendar } from 'vuetify/lib/components/VCalendar';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSheet } from 'vuetify/lib/components/VSheet';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
import { VToolbarTitle } from 'vuetify/lib/components/VToolbar';
installComponents(component, {VCalendar,VCol,VImg,VRow,VSheet,VToolbar,VToolbarTitle})
